import { Stack } from '@mui/material';
import { WsButton, WsTypography, WsTypoVariants } from 'wisestep-base';

interface ConfirmationDialogProps {
  prompt: string;
  confirmText: string;
  skipText: string;
  onConfirm: () => void;
  onSkip: () => void;
}

const ConfirmationDialog = ({
  prompt,
  confirmText,
  skipText,
  onConfirm,
  onSkip,
}: ConfirmationDialogProps) => (
  <Stack p={3} spacing={5}>
    <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
      {prompt}
    </WsTypography>
    <Stack direction="row" spacing={2} justifyContent="flex-end">
      <WsButton onClick={onSkip} variant="text">
        {skipText}
      </WsButton>
      <WsButton onClick={onConfirm} variant="contained">
        {confirmText}
      </WsButton>
    </Stack>
  </Stack>
);

export default ConfirmationDialog;
